/**
 * @generated SignedSource<<d8140e4ee8e852c98e9bc76f2306b3c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ClaimPlayableGlobalPlaythroughPriceInput = {
  amount: number;
  virtualId: number;
};
export type BountiesContextClaimPrizeMutation$variables = {
  input: ClaimPlayableGlobalPlaythroughPriceInput;
};
export type BountiesContextClaimPrizeMutation$data = {
  readonly claimPlayableGlobalPlaythroughPrice: {
    readonly success: boolean;
  } | null;
};
export type BountiesContextClaimPrizeMutation = {
  variables: BountiesContextClaimPrizeMutation$variables;
  response: BountiesContextClaimPrizeMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ClaimPlayableGlobalPlaythroughPricePayload",
    "kind": "LinkedField",
    "name": "claimPlayableGlobalPlaythroughPrice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BountiesContextClaimPrizeMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BountiesContextClaimPrizeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d6d7f84fab2207f4da2c8dad8b2dd073",
    "id": null,
    "metadata": {},
    "name": "BountiesContextClaimPrizeMutation",
    "operationKind": "mutation",
    "text": "mutation BountiesContextClaimPrizeMutation(\n  $input: ClaimPlayableGlobalPlaythroughPriceInput!\n) {\n  claimPlayableGlobalPlaythroughPrice(input: $input) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "8090ed3908070a494628f1e2ff7e82f5";

export default node;
